/*jshint esversion:6 */
import React from "react";
import ATable from "../../common/table";

const SettlementRulesTable = props => {
  const columns = [
    {
      header: "S/N",
      width: 50,
      render: row => <div>{props.paginatedCallBack(row.viewIndex)}</div>
    },
    {
      header: "Settlement Rule",
      accessor: "ruleLabel"
    },
    {
      header: "Transaction Type",
      accessor: "transactionType"
    },
    {
      header: "Settlement Type",
      accessor: "settlementType"
    }
  ];
  return (
    <ATable
      className="-striped -highlight"
      tableData={props.settlementRules}
      columns={columns}
      onChange={props.onTableChange || null}
      manual
      {...props}
    />
  );
};

export default SettlementRulesTable;



// WEBPACK FOOTER //
// ./src/components/settlement/settlementRules/settlementRulesTable.js